const id = {
  createTemplateDetail: "Detail Template",
  createTemplateFormCampaignCode: "Kode campaign",
  createTemplateFormCampaignCodeBySystem: "Dapatkan dari sistem",
  createTemplateFormCampaignCodeSelfInput: "Buat sendiri",
  createTemplateFormCategory: "Kategori template",
  createTemplateFormCategorySubText:
    "Kategori template memudahkan dalam memilah jenis pesan untuk broadcast dan analisis.",
  createTemplateFormSender: "Nama dan alamat email pengirim",
  createTemplateFormSenderSubText:
    "Info pengirim broadcast yang ditampikan ke penerima",
  createTemplateFormSenderNamePlaceholder:
    "Masukkan nama pengirim. Contoh: Kokatto Team",
  createTemplateFormSenderEmailPlaceholder: "Masukkan alamat email",
  createTemplateFormSubjectPlaceholder: "Masukkan judul email",
  createTemplateFormSubject: "Subject email",
  createTemplateFormSubjectSubText:
    "Judul singkat akan muncul di inbox email penerima",
  createTemplateFormCampaignCodeSelfInputPlaceholder:
    "Masukkan kode campaign. Contoh: S01",
  createTemplateFormCampaignCodeExistError:
    "Kode sudah digunakan, silakan coba nomor lain",
  createTemplateFormSenderName: "Nama pengirim",
  createTemplateFormSenderEmail: "Email pengirim",
  createTemplateNextButton: "Selanjutnya",
  createTemplateFormSubjectEmailAliasError: "Tidak bisa lebih dari 60 karakter",
  createTemplateFormCampaignCodeError:
    "Kode campaign harus berjumlah 3 karakter",
  createTemplateCampaignCodeFailedGeneratingErrorMessage:
    "Gagal mendapatkan kode. Coba kembali",
  disableCreateButtonTooltip:
    "Domain email tidak tersedia. Silakan hubungi admin untuk mendapatkan domain email.",
  getProviderEmailFailedSnackbar: "Gagal mendapatkan data provider.",

  createTemplateContent: "Konten {0}",
  createTemplateContentEmail: "Konten Email",
  createTemplateContentEmailSubText:
    "Akan muncul dibagian paling awal dari email anda. Biasanya hanya diisi dengan gambar atau teks berukuran besar.",
  createTemplateEmailSuccessText: "Email template berhasil disimpan",
  createTemplateEmailErrorAlertDuplicate:
    "Kode campaign sudah pernah terdaftar. Silakan ganti kode campaign atau hapus template sebelumnya.",
  createTemplateEmailErrorRole:
    "Role tidak memiliki akses untuk membuat template.",
  createTemplateEmailErrorRequiredParameter:
    "Role tidak memiliki akses untuk membuat template.",
  createTemplateFailedText: "Gagal membuat template",
  createTemplateEmailNextButton: "Selanjutnya",
  createTemplateEmailSaveButton: "Simpan template",
  createTemplateFailedUploadText: "Gagal upload file. Silakan coba lagi.",
  createTemplateContentEmailError: "Konten wajib diisi",
  createTemplateContentEmailFormatError:
    "Variable tidak boleh mengandung spasi",
  createTemplateAttachmentEmail: "Lampiran Media Email",
  createTemplateAttachmentEmailSubText:
    "Jika ingin menggunakan lampiran, pastikan untuk menambahkan URL lampiran saat mengirim broadcast.",

  createTemplatePreviewButton: "Preview {0}",
  createTemplatePreview: "Preview template",
  createTemplatePreviewBackText: "Kembali",
  createTemplatePreviewToMe: "to me",
  createTemplatePreviewUnsubscribe: "Unsubscribe",
  createTemplateVoicePreviewNoScenario:
    "Belum ada skenario yang terhubung dengan campaign ini.",
  createTemplateChangePreview: "Ubah Preview",

  getDetailTemplateFailedText:
    "Gagal mendapatkan detail template. Silakan coba lagi.",
  carousel: "Carousel",
  carouselCardNamePrefix: "Card {0}",
  carouselCardAdd: "Tambah",
  carouselMediaType: "Tipe media",
  carouselmediaTypeDescription:
    "Pilih media image atau video. Setiap card harus dengan media yang sama",
  carouselMediaTypePlaceholder: "Pilih media",
  carouselCardLabel: "Card carousel",
  carouselCardLimit: "Maksimal dapat menambahkan {0} card",
  carouselCardSubLabel: "Pastikan card terisi sebelum menambah baru",
  carouselCardSetting: "Pengaturan carousel",
  carouselCardSettingDescription:
    "Tambahkan media, pesan dan tombol di masing- masing card",
  carouselMediaTypeImage: "Gambar",
  carouselMediaTypeVideo: "Video",
  carouselButtonTypeUrlStatic: "Static",
  carouselButtonTypeUrlDynamic: "Dynamic",
  carouselButtonTypeCtaCallPhone: "Panggil nomor",
  carouselButtonTypeCtaVisitWebsite: "Kunjungi situs web",
  carouselCardAddMedia: "Upload gambar atau video",
  carouselCardMediaVideoNotSupported: "Browser anda tidak mendukung video",
  carouselCardMessageBubbleLabel: "Message bubble",
  carouselCardDynamicButtonAddButton: "Tambahkan tombol",
  carouselCardDynamicButtonAddButtonDescription:
    "Maksimun {0} tombol quick reply dan atau ajakan bertindak",
  carouselButtonTypeMissmatch: "Tipe tombol di setiap carousel harus sama",
  createTemplateCarouselEmptyCarouselSample:
    "Pastikan variabel contoh konten di setiap card terisi",
  createTemplateFormCustomReportTitle: "Custom Report Field",
  createTemplateFormCustomReportDescription:
    "Tambahkan data kustom ke data laporan Anda untuk menyertakan detail tambahan pada broadcast.",
  createTemplateFormDynamicDataReplacementTitle: "Update data dinamis",
  createTemplateFormDynamicDataReplacementDescription:
    "Ganti data kontak lama dengan data baru secara otomatis dalam broadcast.",
  createTemplateAddMoreCustomData: "Tambah",
  createTemplateOptionalDataSection: "Data tambahan (Opsional)",
  createTemplateParameterPlaceholder: "Contoh: Nama",

  createTemplateSenderName: "Nama pengirim",
  createTemplateSenderNameSubText:
    "Nama pengirim ini akan muncul sebagai nama pengirim SMS anda",
  createTemplateContentSMSSubText:
    "Tentukan isi pesan yang ingin dikirimkan kepada pelanggan Anda. Pastikan pesan Anda singkat, jelas, dan sesuai dengan kebutuhan.",
  createContentPlaceholder: "Masukkan teks untuk konten sms",
  createContentPlaceholderVoice:
    "Masukkan teks yang akan dibacakan sebagai pesan suara kepada pelanggan Anda",

  createTemplateVoiceAgentLabel: "Agen Robocall",
  createTemplateVoiceAgentSubText:
    "Pilih agen yang skenarionya akan dijalankan untuk campaign ini",
  createTemplateVoiceAgentPlaceholder: "Pilih agen",
  createTemplateVoiceAgentRequiredError: "Agen wajib dipilih",
  createTemplateVoiceAgentAssignedSuffix: " (Terpakai di campaign {0})",
  createTemplateVoiceScenarioLoading: "Memuat skenario...",
  createTemplateVoiceScenarioLoadFailed: "Gagal memuat skenario agen.",
  createTemplateVoiceRequiredColumnsLabel:
    "Kolom CSV wajib untuk skenario ini:",
  createTemplateVoiceAgentLinkFailed:
    "Campaign berhasil dibuat, tapi gagal menautkan agen ke campaign.",
  createTemplateFormButtonMixed: "Balasan Cepat + Ajakan Bertindak",
  createTemplateFormButtonOrderLabel: "Tampilkan duluan",
  createTemplateFormHeaderMediaFilename: "Nama file",
  createTemplateFormHeaderMediaFilenameHint:
    "Nama file media yang dikirim ke penerima. Kosongkan untuk memakai default.",
  createTemplateFormHeaderMediaFilenameMaxError: "Maksimal 100 karakter.",
  createTemplateFormHeaderMediaFilenameCharError:
    'Nama file tidak boleh mengandung karakter \\ / : * ? " < > |',
  createTemplateFormHeaderMediaFilenameDynamicHint:
    'Nama file diambil dari kolom "Document filename" pada data penerima.',
};

const en = {
  createTemplateDetail: "Template Detail",
  createTemplateFormCampaignCode: "Campaign Code",
  createTemplateFormCampaignCodeBySystem: "Generated by system",
  createTemplateFormCampaignCodeSelfInput: "Set manually",
  createTemplateFormCategory: "Template Category",
  createTemplateFormCategorySubText:
    "Template cateogry helps you in sorting out message type for broadcast and analysing.",
  createTemplateFormSender: "Sender name and email address",
  createTemplateFormSenderSubText:
    "Broadcast sender info displayed to the recipient",
  createTemplateFormSenderNamePlaceholder:
    "Enter sender name. Example: Kokatto Team",
  createTemplateFormSenderEmailPlaceholder: "Enter email address",
  createTemplateFormSubjectPlaceholder: "Enter email subject",
  createTemplateFormSubject: "Email subject",
  createTemplateFormSubjectSubText:
    "Brief title that appears in the recipient's email inbox",
  createTemplateFormCampaignCodeSelfInputPlaceholder:
    "Enter campaign code. Example: S01",
  createTemplateFormCampaignCodeExistError:
    "Code is already used, please use other numbers",
  createTemplateFormSenderName: "Sender name",
  createTemplateFormSenderEmail: "Email Address",
  createTemplateNextButton: "Next",
  createTemplateFormSubjectEmailAliasError: "Can't be more than 60 characters",
  createTemplateFormCampaignCodeError:
    "Campaign code must be exactly 3 characters",
  createTemplateCampaignCodeFailedGeneratingErrorMessage:
    "Failed to get code. Please try again",
  disableCreateButtonTooltip:
    "Email domain not available. Please contact the admin to obtain an email domain.",
  getProviderEmailFailedSnackbar: "Failed to load provider information.",

  createTemplateContent: "{0} Content",
  createTemplateContentEmail: "Email Content",
  createTemplateContentEmailSubText:
    "This will appear at the very beginning of your email. It is usually filled with a large image or text.",
  createTemplateSuccessText: "Email template successfully saved.",
  createTemplateEmailErrorAlertDuplicate:
    "Campaign code is already registered. Please use a different campaign code or delete the previous template.",
  createTemplateEmailErrorRole:
    "Role does not have permission to create templates.",
  createTemplateFailedText: "Failed to create the template.",
  createTemplateEmailNextButton: "Save",
  createTemplateEmailSaveButton: "Save template",
  createTemplateFailedUploadText: "Failed to upload file. Please try again.",
  createTemplateContentEmailError: "Content is required",
  createTemplateContentEmailFormatError: "Variable cannot contain space",
  createTemplateAttachmentEmail: "Media email",
  createTemplateAttachmentEmailSubText:
    "If you want to include an attachment, make sure to add the attachment URL when sending the broadcast",

  createTemplatePreviewButton: "Preview {0}",
  createTemplatePreview: "Preview template",
  createTemplatePreviewBackText: "Back",
  createTemplatePreviewToMe: "to me",
  createTemplatePreviewUnsubscribe: "Unsubscribe",
  createTemplateVoicePreviewNoScenario:
    "No scenario is linked to this campaign yet.",
  createTemplateChangePreview: "Change Preview",

  getDetailTemplateFailedText:
    "Failed to get template detail. Please try again",
  carousel: "Carousel",
  carouselCardNamePrefix: "Card {0}",
  carouselCardAdd: "Add",
  carouselMediaType: "Media type",
  carouselmediaTypeDescription:
    "Choose image or video. Every cards can need to have the same media type",
  carouselMediaTypePlaceholder: "Choose media",
  carouselCardLabel: "Carousel card",
  carouselCardLimit: "You can add up to {0} cards",
  carouselCardSubLabel: "Ensure each card is complete before adding another",
  carouselCardSetting: "Carousel setting",
  carouselCardSettingDescription: "Add media, message and button on each cards",
  carouselMediaTypeImage: "Image",
  carouselMediaTypeVideo: "Video",
  carouselButtonTypeUrlStatic: "Static",
  carouselButtonTypeUrlDynamic: "Dynamic",
  carouselButtonTypeCtaCallPhone: "Call phone number",
  carouselButtonTypeCtaVisitWebsite: "Visit website",
  carouselCardAddMedia: "Upload image or video",
  carouselCardMediaVideoNotSupported:
    "Your browser does not support the video tag",
  carouselCardMessageBubbleLabel: "Message bubble",
  carouselCardDynamicButtonAddButton: "Add buttons",
  carouselCardDynamicButtonAddButtonDescription:
    "Add up to {0} quick reply and/or call to action buttons",
  carouselButtonTypeMissmatch:
    "Button types must be consistent across all carousel cards",
  createTemplateCarouselEmptyCarouselSample:
    "Ensure variable sample content is filled in each card",
  createTemplateFormCustomReportTitle: "Custom Report Field",
  createTemplateFormCustomReportDescription:
    "Add custom fields to your report data to include additional details for broadcasts.",
  createTemplateFormDynamicDataReplacementTitle: "Dynamic data replacement",
  createTemplateFormDynamicDataReplacementDescription:
    "Automatically replace old contact data with new values in your broadcast.",
  createTemplateAddMoreCustomData: "Add",
  createTemplateOptionalDataSection: "Additional data (Optional)",
  createTemplateParameterPlaceholder: "Example: Name",

  createTemplateSenderName: "Sender name",
  createTemplateSenderNameSubText:
    "Sender name will appear on your SMS sender title",
  createTemplateContentSMSSubText:
    "Determine the content of the message you want to send to your customers. Make sure your message is short, clear, and appropriate to their needs.",
  createContentPlaceholder: "Enter text for sms content",
  createContentPlaceholderVoice:
    "Enter the text that will be read aloud as a voice message to your customers",

  createTemplateVoiceAgentLabel: "Robocall Agent",
  createTemplateVoiceAgentSubText:
    "Choose the agent whose scenario will run for this campaign",
  createTemplateVoiceAgentPlaceholder: "Select an agent",
  createTemplateVoiceAgentRequiredError: "Agent is required",
  createTemplateVoiceAgentAssignedSuffix: " (Used in campaign {0})",
  createTemplateVoiceScenarioLoading: "Loading scenario...",
  createTemplateVoiceScenarioLoadFailed: "Failed to load the agent's scenario.",
  createTemplateVoiceRequiredColumnsLabel:
    "Required CSV columns for this scenario:",
  createTemplateVoiceAgentLinkFailed:
    "Campaign was created, but linking the agent to the campaign failed.",
  createTemplateFormButtonMixed: "Quick Reply + Call to Action",
  createTemplateFormButtonOrderLabel: "Show first",
  createTemplateFormHeaderMediaFilename: "File name",
  createTemplateFormHeaderMediaFilenameHint:
    "Media file name sent to the recipient. Leave empty to use the default.",
  createTemplateFormHeaderMediaFilenameMaxError: "Maximum 100 characters.",
  createTemplateFormHeaderMediaFilenameCharError:
    'File name cannot contain \\ / : * ? " < > |',
  createTemplateFormHeaderMediaFilenameDynamicHint:
    'File name is taken from the "Document filename" column in the receiver data.',
};

export default { id, en };
